<template>
    <div>
        <main v-if="mobileCheck">
            <section class="slogan">
                <div class="main-title">
                    <h1>{{ $t('lp-collection17') }}</h1>
                    <div class="main-subtitle">{{ $t('lp-collection18') }}</div>
                    <nuxt-link :to="localePath('/register')" class="home-section1-btn1 v-btn__content ga4-reg-btn">{{ $t("lp-collection24") }}</nuxt-link>
                    <nuxt-link :to="localePath('/app')" class="home-section1-btn2">Download app</nuxt-link>
                </div>
            </section>
            <div class="home-tab-container">
                <section id="how-to-buy" class="section-how-to-buy">
                    <h2>{{ $t("home-title3") }}</h2>
                    <div class="title-border"></div>
                    <div class="container1366 padding200">
                        <div :class="$i18n.locale.toLowerCase() === 'de' ? 'how-buy-live-market-wrapper-de' : 'how-buy-live-market-wrapper'">
                            <div class="home-left-50">
                                <nuxt-link :to="localePath('/trading-desk')">
                                    <div class="section-how-to-buy-img2"></div>
                                </nuxt-link>
                            </div>
                            <div class="home-right-50">
                                <i18n path="howitworks8" tag="div" class="content-text">
                                    <nuxt-link :to="localePath('/trading-desk')" place="tobereplaced">{{ $t('home-title3') }}</nuxt-link>
                                </i18n>
                                <nuxt-link :to="localePath('/trading-desk')" class="blue-btn how-to-btn">{{ $t("new-home3") }}</nuxt-link>
                            </div>
                        </div>
                    </div>
                </section>

                <div class="container home-collections-container">
                    <h2 v-if="popularEnWines.length" class="home-title home-title-live">
                        {{ $t('latest-offers') }}
                        <a href="/en-primeur" class="show-all-btn">{{ $t('enprimeur14') }}</a>
                    </h2>
                    <HomePopularWines v-if="popularEnWines.length" :wines-list="popularEnWines"></HomePopularWines>
                </div>
            </div>

            <section class="lp-register">
                <div class="container1366 padding200 padding80">
                    <div class="marginBottom16">Register now and get free storage and insurance when you purchase your first Collection</div>
                    <nuxt-link :to="localePath('/register')" class="home-section1-btn1 v-btn__content ga4-reg-btn">Register Now</nuxt-link>
                </div>
            </section>

            <section class="home-section2">
                <div class="container1366 padding200">
                    <div class="home-left-50">
                        <div class="home-section2-img">
                            <nuxt-img alt="chart image" v-if="$i18n.locale === 'it'" format="webp" provider="static" fit="cover" src="/home_chart_it.svg" />
                            <nuxt-img alt="chart image" v-else-if="$i18n.locale === 'fr'" format="webp" provider="static" fit="cover" src="/home_chart_fr.svg" />
                            <nuxt-img alt="chart image" v-else-if="$i18n.locale === 'de'" format="webp" provider="static" fit="cover" src="/home_chart_de.svg" />
                            <nuxt-img alt="chart image" v-else-if="$i18n.locale === 'ru'" format="webp" provider="static" fit="cover" src="/home_chart_ru.svg" />
                            <nuxt-img alt="chart image" v-else format="webp" provider="static" fit="cover" src="/home_chart.svg" />
                        </div>
                    </div>
                    <div class="home-right-50">
                        <h2 class="home-section2-title home-section2-title2">{{ $t("new-home5") }}</h2>
                        <div class="home-section2-subtitle">{{ $t("new-home6") }}</div>
                        <div class="home-section2-bullets">
                            <div class="home-section2-bullet">{{ $t("new-home7") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home8") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home9") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home10") }}</div>
                        </div>
                        <div class="home-section2-btn-wrapper">
                            <nuxt-link @click.native="goSection('investment-guide')" :to="localePath('/wine-academy')" class="home-section2-btn1">{{ $t("new-home4") }}</nuxt-link>
                            <nuxt-link :to="localePath('/register')" class="home-section2-btn2 ga4-reg-btn">{{ $t("new-home11") }}</nuxt-link>
                        </div>
                    </div>
                </div>
            </section>

            <section class="home-section3">
                <div class="container1366 padding200">
                    <div class="home-left-50">
                        <div class="home-section3-img">
                            <nuxt-img alt="pie chart image" v-if="$i18n.locale === 'it'" format="webp" provider="static" fit="cover" src="/home_pie_chart_it.svg" />
                            <nuxt-img alt="pie chart image" v-else-if="$i18n.locale === 'fr'" format="webp" provider="static" fit="cover" src="/home_pie_chart_fr.svg" />
                            <nuxt-img alt="pie chart image" v-else-if="$i18n.locale === 'de'" format="webp" provider="static" fit="cover" src="/home_pie_chart_de.svg" />
                            <nuxt-img alt="pie chart image" v-else format="webp" provider="static" fit="cover" src="/home_pie_chart.svg" />
                        </div>
                    </div>
                    <div class="home-right-50">
                        <h2 class="home-section2-title">{{ $t("new-home12") }}</h2>
                        <div class="home-section2-subtitle">{{ $t("new-home13") }}</div>
                        <div class="home-section2-bullets">
                            <div class="home-section2-bullet">{{ $t("new-home14") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home15") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home16") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home17") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home18") }}</div>
                        </div>
                        <div class="home-section2-btn-wrapper">
                            <nuxt-link @click.native="goSection('academy-container')" :to="localePath('/wine-academy')" class="home-section2-btn1">{{ $t("new-home4") }}</nuxt-link>
                        </div>
                    </div>
                </div>
            </section>
        </main>
        <main v-else>
            <section class="slogan">
                <div class="main-title">
                    <h1>{{ $t('lp-collection17') }}</h1>
                    <div class="main-subtitle">{{ $t('lp-collection18') }}</div>
                    <nuxt-link :to="localePath('/register')" class="home-section1-btn1 v-btn__content ga4-reg-btn">Register now</nuxt-link>
                    <nuxt-link :to="localePath('/app')" class="home-section1-btn2">Download app</nuxt-link>
                </div>
            </section>

            <section id="how-to-buy" class="section-how-to-buy">
                <h2>{{ $t("home-title3") }}</h2>
                <div class="title-border"></div>
                <div class="container1366 padding200">
                    <div :class="$i18n.locale.toLowerCase() === 'de' ? 'how-buy-live-market-wrapper-de' : 'how-buy-live-market-wrapper'">
                        <div class="home-left-50">
                            <nuxt-link :to="localePath('/trading-desk')">
                                <div class="section-how-to-buy-img2"></div>
                            </nuxt-link>
                        </div>
                        <div class="home-right-50">
                            <i18n path="howitworks8" tag="div" class="content-text">
                                <nuxt-link :to="localePath('/trading-desk')" place="tobereplaced">{{ $t('home-title3') }}</nuxt-link>
                            </i18n>
                            <nuxt-link :to="localePath('/trading-desk')" class="blue-btn how-to-btn">{{ $t("new-home3") }}</nuxt-link>
                        </div>
                    </div>
                </div>
            </section>

            <section id="latest-offers">
                <div class="container1366 padding200 padding80">
                    <h2 class="home-title">{{ $t('latest-offers') }}</h2>
                    <div class="title-border"></div>
                    <div class="latest-offers-wrapper">
                        <HomePopularWines v-if="popularEnWines.length" :wines-list="popularEnWines"></HomePopularWines>
                        <nuxt-link :to="localePath('/trading-desk/EnPrimeur')" class="show-all-btn">{{ $t('enprimeur14') }}</nuxt-link>
                    </div>
                </div>
            </section>

            <section class="lp-register">
                <div class="container1366 padding200 padding80">
                    <div class="marginBottom16">Register now and get free storage and insurance when you purchase your first Collection</div>
                    <nuxt-link :to="localePath('/register')" class="home-section1-btn1 v-btn__content ga4-reg-btn">Register Now</nuxt-link>
                </div>
            </section>

            <section class="home-section2">
                <div class="container1366 padding200">
                    <div class="home-left-50">
                        <div class="home-section2-img">
                            <nuxt-img alt="chart image" v-if="$i18n.locale === 'it'" format="webp" provider="static" fit="cover" src="/home_chart_it.svg" />
                            <nuxt-img alt="chart image" v-else-if="$i18n.locale === 'fr'" format="webp" provider="static" fit="cover" src="/home_chart_fr.svg" />
                            <nuxt-img alt="chart image" v-else-if="$i18n.locale === 'de'" format="webp" provider="static" fit="cover" src="/home_chart_de.svg" />
                            <nuxt-img alt="chart image" v-else-if="$i18n.locale === 'ru'" format="webp" provider="static" fit="cover" src="/home_chart_ru.svg" />
                            <nuxt-img alt="chart image" v-else format="webp" provider="static" fit="cover" src="/home_chart.svg" />
                        </div>
                    </div>
                    <div class="home-right-50">
                        <h2 class="home-section2-title home-section2-title2">{{ $t("new-home5") }}</h2>
                        <div class="home-section2-subtitle">{{ $t("new-home6") }}</div>
                        <div class="home-section2-bullets">
                            <div class="home-section2-bullet">{{ $t("new-home7") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home8") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home9") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home10") }}</div>
                        </div>
                        <div class="home-section2-btn-wrapper">
                            <nuxt-link @click.native="goSection('investment-guide')" :to="localePath('/wine-academy')" class="home-section2-btn1">{{ $t("new-home4") }}</nuxt-link>
                            <nuxt-link :to="localePath('/register')" class="home-section2-btn2 ga4-reg-btn">{{ $t("new-home11") }}</nuxt-link>
                        </div>
                    </div>
                </div>
            </section>
            <section class="home-section3">
                <div class="container1366 padding200">
                    <div class="home-left-50">
                        <h2 class="home-section2-title">{{ $t("new-home12") }}</h2>
                        <div class="home-section2-subtitle">{{ $t("new-home13") }}</div>
                        <div class="home-section2-bullets">
                            <div class="home-section2-bullet">{{ $t("new-home14") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home15") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home16") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home17") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home18") }}</div>
                        </div>
                        <div class="home-section2-btn-wrapper">
                            <nuxt-link @click.native="goSection('academy-container')" :to="localePath('/wine-academy')" class="home-section2-btn1">{{ $t("new-home4") }}</nuxt-link>
                        </div>
                    </div>
                    <div class="home-right-50">
                        <div class="home-section3-img">
                            <nuxt-img alt="pie chart image" v-if="$i18n.locale === 'it'" format="webp" provider="static" fit="cover" src="/home_pie_chart_it.svg" />
                            <nuxt-img alt="pie chart image" v-else-if="$i18n.locale === 'fr'" format="webp" provider="static" fit="cover" src="/home_pie_chart_fr.svg" />
                            <nuxt-img alt="pie chart image" v-else-if="$i18n.locale === 'de'" format="webp" provider="static" fit="cover" src="/home_pie_chart_de.svg" />
                            <nuxt-img alt="pie chart image" v-else format="webp" provider="static" fit="cover" src="/home_pie_chart.svg" />
                        </div>
                    </div>
                </div>
            </section>
        </main>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import HomePopularWines from "../components/home/HomePopularWines";
    import {GCommon, GMarket} from "../store/getters";
    import {AMarket} from "../store/actions";
    import 'vueperslides/dist/vueperslides.css'

    export default {
        name: 'LpLiveMarketPurchase2',
        head: {
            title: 'En Primeur Purchase | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'home page-lp-collections'
            }
        },
        components: {
            HomePopularWines
        },
        data() {
            return {
                popularEnWines: []
            }
        },
        computed: {
            ...mapGetters({
                topEnWines: GMarket.GET_TOP_EN_WINES,
                wineItems: GMarket.GET_WINES,
                mobileCheck: GCommon.GET_MOBILE_VERSION
            }),
            popularEnWinesIds() {
                let _list = [];
                this.topEnWines.forEach(el => {
                    _list.push(el.wineId)
                });
                return _list
            }
        },
        methods: {
            goSection(val) {
                this.$nuxt.$emit("goToSection", val);
            }
        },
        created (){
            let homeCtrl = this;
            this.$store.dispatch(AMarket.GET_HOME_WINES).then(() => {
                homeCtrl.$store.dispatch(AMarket.GET_TOP_EN_WINES).then(() => {
                    let addedWines = 0;

                    homeCtrl.wineItems.forEach(wine => {
                        if (homeCtrl.popularEnWinesIds.indexOf(wine.wineId) > -1 && addedWines < 10) {
                            homeCtrl.popularEnWines.push(wine)
                            addedWines++
                        }
                    })
                });
            })
        }
    };
</script>

<style scoped>
.marginBottom16 {
    margin-bottom: 16px;
}
.home-section1-btn1 {
    background: #FFFFFF;
    border-radius: 8px;
    padding: 8px 16px;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    display: inline-block;
    color: #004F7F;
}
.home-section1-btn2 {
    background: transparent;
    border: 1px solid #ffffff;
    border-radius: 8px;
    padding: 8px 16px;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    display: inline-block;
    color: #ffffff;
    margin-left: 16px;
}
.home-section2 {
    height: 430px;
    padding: 52px 0 45px;
}
.home-section2-img, .home-section3-img {
    height: 100%;
    width: 100%;
}
.home-section2-img img,
.home-section3-img img {
    background-size: contain;
    height: 100%;
    width: 100%;
}
.home-section2-title {
    color: #002840;
    font-family: Montserrat,Arial,Helvetica,sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    margin-bottom: 8px;
    margin-top: 39px;
    text-align: left;
}
.home-section2-subtitle {
    align-items: center;
    display: flex;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 24px;
}
.home-section2-bullet,
.home-section2-subtitle {
    color: #002840;
    font-family: Montserrat,Arial,Helvetica,sans-serif;
    font-style: normal;
}
.home-section2-bullet {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #002840;
    padding-left: 17px;
    background: url("../assets/home/bullet-point.svg") no-repeat left center;
}
.home-section2-bullets {
    margin-bottom: 24px;
}
.home-section2-btn1 {
    padding: 8px 16px;
    height: 36px;
    background: #004F7F;
    border-radius: 8px;
    color: #ffffff;
    display: inline-block;
    vertical-align: top;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
}
.home-section2-btn2 {
    display: inline-block;
    vertical-align: top;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    color: #004F7F;
    border: 2px solid #004F7F;
    border-radius: 8px;
    padding: 8px 16px;
    height: 36px;
    margin-left: 12px;
}
.home-section3 {
    padding-bottom: 80px;
}
    .lp-register {
        background: linear-gradient(88.98deg, #003758 0%, #004B79 52.08%, #00629D 100%);
        color: white;
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
    }


    .home ul {
        padding-left: 0;
    }

    .container {
        position: relative;
        max-width: 1170px;
        margin: 0 auto;
        padding: 0 15px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        z-index: 1;
    }
    .container1366 {
        position: relative;
        max-width: 1366px;
        margin: 0 auto;
        padding: 0 15px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        z-index: 1;
    }
    .padding200 {
        padding: 0 200px;
    }
    .padding80 {
        padding-top: 80px;
        padding-bottom: 80px;
    }
    .title-border {
        width: 64px;
        height: 4px;
        background: #ECD9A7;
        margin: 24px auto 40px;
    }

    .hidden {
        display: none;
    }

    /* reset */

    body, div, dl, dt, dd, ul, li, h1, h2, h3, h4, h5, h6, pre, code, form, fieldset, input, textarea, p, blockquote, th, td {
        margin: 0;
        padding: 0;
    }

    table {
        border-spacing: 0;
        border-collapse: collapse;
    }

    fieldset, img, abbr {
        border: 0;
    }

    address, caption, cite, code, dfn, em, strong, th, var {
        font-weight: normal;
        font-style: normal;
    }

    ul li {
        list-style: none;
    }

    caption, th {
        text-align: left;
    }

    button {
        border: none;
        background: none;
    }

    button:hover {
        cursor: pointer;
    }

    a {
        text-decoration: none;
    }

    /* slogan section */
    .section-how-to-buy {
        padding-top: 80px;
        padding-bottom: 80px;
    }
    .how-buy-live-market-wrapper {
        height: 241px;
        margin-top: 40px;
    }
    .how-buy-live-market-wrapper-de {
        height: 285px;
        margin-top: 40px;
    }
    h2 {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 29px;
        color: #002840;
        text-align: center;
    }
    .section-how-to-buy-img2 {
        background: url("../assets/home/home_live_market.png") no-repeat center;
        background-size: cover;
        width: 100%;
        height: 100%;
    }
    .home-left-50,
    .home-right-50 {
        display: inline-block;
        width: calc((100% - 24px) / 2);
        height: 100%;
        vertical-align: top;
    }

    .home-left-50 {
        margin-right: 20px;
    }
    .blue-btn {
        padding: 8px 16px;
        height: 36px;
        background: #004F7F;
        border-radius: 8px;
        color: #ffffff;
        display: inline-block;
        vertical-align: top;
        font-family: "Montserrat", Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        text-decoration: none;
        margin-top: 24px;
    }
    .blue-btn:hover {
        cursor: pointer;
    }
    .content-text {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        color: #002840;
        padding-top: 30px;
    }
    .slogan {
        height: 480px;
        margin-top: 80px;
        position: relative;
        background: linear-gradient(180deg, #00304D 0%, rgba(0, 48, 77, 0) 30%), url('../assets/landing/livemarket2.svg') no-repeat center;
        background-size: cover;
    }

    .main-title {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin: 120px auto 0;
        text-align: center;
        max-width: 966px;
    }
    .main-title h1 {
        color: #ffffff;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 36px;
        line-height: 44px;
        margin-bottom: 0;
    }
    .main-subtitle {
        margin-top: 16px;
        margin-bottom: 32px;
        text-align: center;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 27px;
        color: #ffffff;
    }
    .iframe-container {
        width: 100%;
        left: 0;
        right: 0;
        margin: 0 auto;
    }
    .iframe-container iframe {
        border: 0;
        width: 100%;
        height: 132px;
        border-radius: 32px;
    }

    /* START Top Collections */
    .home-title {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 29px;
        color: #002840;
        margin-bottom: 24px;
        position: relative;
        text-align: center;
    }

    .show-all-btn {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        padding: 8px 16px;
        width: 120px;
        height: 36px;
        background: #004F7F;
        border-radius: 8px;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        display: block;
        color: #FFFFFF;
        text-align: center;
        margin: 0 auto;
    }

    .home-collections-container {
        max-width: 1214px;
        margin: 0 auto;
    }

    /* END Top Collections */

    .home-title-wine {
        text-align: center;
        font-weight: 400;
        font-size: 40px;
        line-height: 47px;
        margin: 24px auto 40px;
    }
    .home-title-live {
        margin-top: 50px;
    }

    #latest-offers {
        background-color: #F7F7F7;
    }
    .latest-offers-wrapper {
        margin-top: 16px;
    }

    @media(max-width: 767px) {
        .home-section2, .home-section3 {
            height: auto;
            padding: 16px 0;
        }
        .home-section2 .container1366, .home-section3 .container1366 {
            height: 100%;
        }
        .home-left-50 {
            height: 200px;
            margin-right: 0;
        }
        .home-left-50, .home-right-50 {
            display: block;
            width: 100%;
        }
        .home-section3 .home-left-50 {
            height: auto;
        }
        .how-buy-live-market-wrapper, .how-buy-live-market-wrapper-de {
            height: auto;
        }
        .home-left-50, .home-right-50 {
            display: block;
            width: 100%;
        }
        .section-how-to-buy-img2 {
            height: 200px;
        }
        .main-title {
            font-size: 22px;
            line-height: 36px;
            margin: 70px auto;
        }
        .home-title {
            font-size: 17px;
            line-height: 17px;
            font-weight: 700;
        }
        .collections-h1 {
            font-size: 22px;
        }
        .show-all-btn {
            display: none;
        }
        .padding200 {
            padding: 0 16px;
        }
        .padding80 {
            padding-top: 32px;
            padding-bottom: 32px;
        }
    }
</style>

<style>
.page-lp-collections .not-logged-btn-wrapper {
    display: none;
}
.page-lp-collections .site-navigation-not-logged {
    position: absolute;
    right: 32px;
    top: 24px;
}
.page-lp-collections .site-navigation-not-logged li {
    display: none;
}
.page-lp-collections .site-navigation-not-logged li.lang-nav {
    display: block;
}
</style>
